<template>
  <div>
    <div
      class="px-2 py-1.5 rounded-sm min-w-[10rem] mb-2 cursor-pointer hover:opacity-80 transition-opacity"
      :class="{
        'bg-slate-50 dark:bg-slate-600 dark:text-slate-50':
          messageType === MESSAGE_TYPE.INCOMING,
        'bg-woot-600 text-woot-50': messageType === MESSAGE_TYPE.OUTGOING,
        '-mx-2': !parentHasAttachments,
      }"
      @click="handleReplyClick"
    >
      <message-preview
        :message="message"
        :show-message-type="false"
        :default-empty-message="$t('CONVERSATION.REPLY_MESSAGE_NOT_FOUND')"
      />
    </div>
    
    <!-- Image display mode -->
    <gallery-view
      v-if="showImageGallery"
      :show.sync="showImageGallery"
      :attachment="firstImageAttachment"
      :all-attachments="imageAttachments"
      @close="closeImageGallery"
    />
  </div>
</template>

<script>
import MessagePreview from 'dashboard/components/widgets/conversation/MessagePreview.vue';
import { MESSAGE_TYPE } from 'shared/constants/messages';
import GalleryView from 'dashboard/components/widgets/conversation/components/GalleryView.vue';
import { BUS_EVENTS } from 'shared/constants/busEvents';

export default {
  name: 'ReplyTo',
  components: {
    MessagePreview,
    GalleryView,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
    messageType: {
      type: Number,
      required: true,
    },
    parentHasAttachments: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return { 
      MESSAGE_TYPE,
      showImageGallery: false,
    };
  },
  computed: {
    // Returns only image attachments
    imageAttachments() {
      if (!this.message.attachments || this.message.attachments.length === 0) {
        return [];
      }
      return this.message.attachments.filter(attachment => {
        return attachment.file_type === 'image';
      });
    },
    // Returns the first image attachment
    firstImageAttachment() {
      return this.imageAttachments.length > 0 ? this.imageAttachments[0] : null;
    },
    // Check if there is an image attachment
    hasImageAttachment() {
      return this.imageAttachments.length > 0;
    },
  },
  methods: {
    handleReplyClick() {
      if (!this.message || !this.message.id) {
        return;
      }

      if (this.hasImageAttachment) {
        this.showImageGallery = true;
      } else {
        bus.$emit(BUS_EVENTS.SCROLL_TO_MESSAGE, {
          messageId: this.message.id,
        });
      }
    },
    closeImageGallery() {
      this.showImageGallery = false;
    },
  },
};
</script>
